<template>
<div class="wrapper-landing">
    <LandingHero
      title="Maak je gratis multi-shop-wishlist"
      subtitle="Bewaar en deel alles wat je maar kunt wensen."
      buttonText="Maak je wishlist"
      origin="wishlist"
      listType="wishlist"
      logoStyle="white"
      lang="nl-NL"
    >
      <template v-slot:cover>
        <source
          media="(max-width: 991px)"
          class=""
          srcset="../../assets/img/covers/cover-landing-wishlist-desk.jpg"
          alt=""
          loading="lazy"
        />
        <img
          class="ln-hero__inset"
          src="../../assets/img/covers/cover-landing-wishlist-desk.jpg"
          alt=""
          loading="lazy"
        />
      </template>
    </LandingHero>
    <main class="bg-cercles">
      <LandingAppRatings />

      <section class="bb-container">
        <LandingFeaturesSimple title="Je hebt een HelloBB-lijst nodig als:"
        :use-carousel="false"
        >
        <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
            </template>
            <template slot="title">
              Je graag georganiseerd bent en niets wilt vergeten
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
            </template>
            <template slot="title"> Je dingen uit verschillende shops wilt wensen </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
            </template>
            <template slot="title">
              Je op zoek bent naar een eenvoudige en leuke manier om je wensen te delen
            </template>
          </LandingFeaturesSimpleItem>
          <LandingFeaturesSimpleItem>
            <template slot="ico">
              <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
            </template>
            <template slot="title">
                Je omgeving een beetje hulp nodig heeft om de juiste cadeaus te kiezen
            </template>
          </LandingFeaturesSimpleItem>
        </LandingFeaturesSimple>
      </section>
    </main>

    <LandingFeaturesCover title="Een lijst vol mooie dingen">
      <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/covers/cover-retailers-box-int.webp" alt="" />
        </template>
        <template slot="titulo">
          Vraag elk model, elk merk, uit elke winkel
        </template>

        <template slot="descripcion">
          <p>
            Kopieer elke willekeurige link en sla die op in je lijst. Volledige vrijheid om precies te kiezen wat je wilt.
          </p>
        </template>
      </LandingFeaturesCoverItem>
      <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
        </template>
        <template slot="titulo"> Ontvang geld zonder kosten </template>

        <template slot="descripcion">
          <p>
            Je familie en vrienden kunnen je cadeaus geven of je geld sturen zodat je ze zelf kunt kopen. Als eigenaar van de lijst betaal je niets om geld te ontvangen.
          </p>
        </template>
      </LandingFeaturesCoverItem>
      <!-- <LandingFeaturesCoverItem>
        <template slot="cover">
          <img src="../../assets//img/covers/mockup_aportaciones_ES.png" alt="" />
        </template>
        <template slot="titulo"> Ofrece la posibilidad de compartir las compras más caras </template>

        <template slot="descripcion">
          <p>
            Además, tu familia y amigos podrán colaborar con aportaciones parciales
                para comprar las cosas más caras entre todos.
          </p>
        </template>
      </LandingFeaturesCoverItem> -->
      <FeaturesCoverItemListUpdate lang="nl-NL" />
    </LandingFeaturesCover>
    

    <main class="bg-cercles">
      <section class="bb-container">
        <LandingReviewsWedding lang="nl-NL" />
      </section>
    </main>

    <LandingComoCols title="Hoe werkt het?" subtitle="Jouw verlanglijst zonder grenzen">
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
        </template>
        <template slot="titulo">Kies wat je wilt</template>
        <template slot="descripcion">
          <p>
            Kies een artikel uit een willekeurige online winkel, kopieer de link in HelloBB en sla hem op.
          </p>
          <p>
            Je kunt ook een spaarpot aanmaken om geld te verzamelen voor alles wat je wilt.
          </p>
        </template>
      </LandingComoColsItem>
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
        </template>
        <template slot="titulo">Deel je wensen</template>
        <template slot="descripcion">
          <p>Wanneer je maar wilt, deel je lijst met familie en vrienden.</p>
          <p>
            Stuur ze een link zodat ze overal en zonder registratie toegang hebben tot jouw mooi gepersonaliseerde lijst.
          </p>
        </template>
      </LandingComoColsItem>
      <LandingComoColsItem>
        <template slot="icono">
          <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
        </template>
        <template slot="titulo">Ontvang je cadeaus</template>
        <template slot="descripcion">
          <p>
            Je dierbaren kunnen een cadeau uit je lijst kiezen en het kopen.
            Ze kunnen het rechtstreeks naar jou sturen of naar zichzelf laten leveren om het persoonlijk te overhandigen.
          </p>
          <p>
            Om te voorkomen dat hetzelfde cadeau dubbel wordt gekocht, kunnen ze het in de lijst als gegeven markeren.
          </p>
        </template>
      </LandingComoColsItem>
    </LandingComoCols>

    <LandingFooter lang="nl-NL" />
  </div>
</template>

<script>
import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";

import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";

import LandingHero from "./components/LandingHero.vue";
import LandingAppRatings from "./components/LandingAppRatings.vue";
import LandingFeaturesCover from "./components/LandingFeaturesCover";
import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
import LandingHablan from "./components/LandingHablan.vue";
import LandingFooter from "./components/LandingFooter.vue";

import LandingComoCards from "./components/LandingComoCards.vue";
import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
import LandingComoColsItem from "./components/LandingComoColsItem.vue";
import LandingComoCols from "./components/LandingComoCols.vue";

import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";

// import bbButton from "../../components/buttons/bbButton.vue";

export default {
  name: "LandingWishlistNL",
  metaInfo() {
    return {
      title: "HelloBB: jouw verlanglijst zonder grenzen",
      htmlAttrs: {
        lang: "nl",
      },
      meta: [
        { name: "description", content: "HelloBB is de lijst waar echt al jouw wensen in passen." },
        { name: "robots", content: "noindex" },
      ],
    };
  },
  components: {
    LandingComoCols,
    LandingComoColsItem,
    LandingAppRatings,
    LandingHablan,
    LandingReviewsWedding,
    LandingFooter,
    LandingHero,
    LandingFeaturesCover,
    LandingFeaturesCoverItem,
    LandingFeaturesSlider,
    LandingFeaturesSimple,
    LandingFeaturesSimpleItem,
    LandingComoCards,
    LandingComoCardsItem,
    FeaturesCoverItemListUpdate,
  },
};
</script>

<style lang="scss" scoped></style>
